import { Box, Typography, Card, CardMedia, CardContent, CardActions, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ShowcaseOptions = () => {
  const navigate = useNavigate();

  const handleClick = (modelName: string) => {
    navigate("/persona/add-model", { state: { modelName } });
  };

  return (
    <Box
    sx={{
      width: "100%",
      height: "auto",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: 4,
      backgroundColor: "transparent",
      "@media (max-width: 600px)": {
        width: "100%",
      },
    }}
  >
    <Typography
      variant="h5"
      component="div"
      gutterBottom
      sx={{
          fontFamily: 'var(--font-family-primary)',
          fontSize: '24px',
          fontWeight: '400',
          color: '#FFFFFF',
          marginTop: '38px',
          marginBottom: '38px',
          '@media (max-width: 600px)': {
            fontSize: '18px',  
            marginBottom: '20px',  
          }
      }}
    >
      Add your Persona Model
    </Typography>

    <Grid container spacing={6} justifyContent="center">
      {/* Card 1 */}
      <Grid item xs={12} sm={6} md={4} xl={2}>
        <Card
          sx={{
            width: "100%",
            backgroundColor: "transparent",
            boxShadow: "none",
            borderRadius: "15px 15px 0px 0px",
           
          }}
        >
          <CardMedia
            component="img"
            height={160}
            image={'/assets/person.svg'}
            alt="Image 1"
            
          />
          <CardContent />
          <CardActions
          sx={{
            justifyContent: 'center',
          }}>
            <Button
              size="medium"
              onClick={() => handleClick("Person")}
              sx={{
                border: "1px solid #8D49CE",
                color: "#FFFFFF",
                fontFamily: 'var(--font-family-primary)',
                fontWeight: '400',
                fontSize: '17px',
                width: '257px',
                height: '58px',
                borderRadius: '10px',
              }}
            >
              Human Persona
            </Button>
          </CardActions>
        </Card>
      </Grid>

      {/* Card 2 */}
      <Grid item xs={12} sm={6} md={4} xl={2}>
               <Card
          sx={{
            width: "100%",
            backgroundColor: "transparent",
            boxShadow: "none",
            borderRadius: "15px 15px 0px 0px",
          }}
        >
          <CardMedia
            component="img"
                      height={160}

            image={'/assets/AIInfluencer.jpg'}
            alt="Image 2"
          />
          <CardContent />
          <CardActions
            sx={{
              justifyContent: 'center',
            }}>
            <Button
              size="medium"
              onClick={() => handleClick("AiInfluencer")}
              sx={{
                border: "1px solid #8D49CE",
                color: "#FFFFFF",
                fontFamily: 'var(--font-family-primary)',
                fontWeight: '400',
                fontSize: '17px',
                width: '257px',
                height: '58px',
                borderRadius: '10px',
              }}
            >
              AI Persona
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  </Box>
  );
};

export default ShowcaseOptions;
